import { inventoryField, layerHas, layerOf } from '../shared/array-types';

type Row = Record<string, any>;
// Mirrors take_all_preflight_inc.php: gross includes normal nested contents; fixed-weight
// containers absorb incoming weight only AFTER their own storage limit is checked.
export function takeAllCapacityReason(actor: Row | null, entries: Row[], destination: string,
    actorId: string, resolve: (id: string) => Row | null): string {
    let weight = 0;
    for (const row of entries) {
        const value = row.computed?.weight?.gross ?? row.computed?.weight?.total;
        if (value == null || !Number.isFinite(Number(value))) return 'Inventory weight is unavailable. Reopen the container.';
        weight += Number(value);
    }
    let cursor = destination.toUpperCase();
    const seen = new Set<string>();
    while (cursor !== actorId.toUpperCase()) {
        if (!cursor || seen.has(cursor) || seen.size >= 32) return 'The destination is no longer available.';
        seen.add(cursor);
        const bag = resolve(cursor);
        if (!bag) return 'The destination is no longer available.';
        const cap = layerOf(bag, 'carrying_capacity_pounds');
        const held = Number(bag.computed?.weight?.held ?? 0);
        if (cap != null && held + weight > Number(cap) + 0.0001) return 'Cannot take all: the destination container would exceed its carrying capacity.';
        if (layerHas(bag, 'carrying_capacity_fixed_weight')) weight = 0;
        cursor = String(inventoryField(bag, 'possess_id') ?? '').toUpperCase();
    }
    const held = actor?.computed?.creature?.weight?.total_weight_held;
    const cap = actor?.computed?.creature?.capacity?.max?.total ?? layerOf(actor, 'creature_max_carrying_capacity');
    if (held == null || cap == null || !Number.isFinite(Number(held)) || !Number.isFinite(Number(cap))) return 'Carrying capacity is unavailable. Reopen your inventory.';
    return Number(held) + weight > Number(cap) + 0.0001 ? 'Cannot take all: this would exceed your maximum carrying capacity.' : '';
}
